export const comicCategories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', count: 256 },
  { slug: 'aiqing', name: '恋爱', icon: 'ri-heart-line', count: 189 },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', count: 312 },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 145 },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', count: 98 },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', count: 167 },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-line', count: 203 },
  { slug: 'richang', name: '日常', icon: 'ri-sun-line', count: 178 },
];

export const categories = comicCategories;

export const comics = [
  {
    id: 1,
    slug: 'yi-quan-chao-ren',
    title: '一拳超人',
    author: 'ONE / 村田雄介',
    category: '热血',
    categorySlug: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20a%20bald%20superhero%20in%20yellow%20costume%20with%20red%20cape%2C%20dynamic%20action%20pose%2C%20clean%20white%20background%2C%20bold%20linework%2C%20vibrant%20colors%2C%20professional%20manga%20illustration%20style&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    rating: 9.7,
    views: '3.2亿',
    status: '连载中',
    description: '主人公埼玉原本是一名整日奔波于求职的普通人，三年前偶然遇到要对淘气少年下杀手的异变螃蟹人后，回忆起年少年时想要成为英雄的梦想，最终拼尽全力救下了淘气少年。之后通过拼命锻炼，埼玉终于脱胎换骨获得了最强的力量，但同时失去了头发成了光头。',
    updateChapter: '第245话',
    updateDate: '2026-07-02',
    chapters: 245,
    isHot: true,
    isNew: false,
    rank: 1,
    tags: ['英雄', '战斗', '搞笑'],
  },
  {
    id: 2,
    slug: 'gui-mie-zhi-ren',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: '热血',
    categorySlug: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20young%20warrior%20with%20green%20checkered%20haori%20holding%20katana%2C%20dark%20blue%20night%20background%20with%20moon%2C%20water%20breathing%20effect%2C%20dramatic%20lighting%2C%20clean%20manga%20illustration&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    rating: 9.5,
    views: '5.8亿',
    status: '已完结',
    description: '时值日本大正时期，传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭少年炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。',
    updateChapter: '第205话（完结）',
    updateDate: '2025-12-15',
    chapters: 205,
    isHot: true,
    isNew: false,
    rank: 2,
    tags: ['战斗', '妖怪', '历史'],
  },
  {
    id: 3,
    slug: 'jian-lai',
    title: '剑来',
    author: '烽火戏诸侯',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20cover%2C%20young%20swordsman%20in%20traditional%20white%20robe%20holding%20ancient%20sword%2C%20floating%20in%20clouds%2C%20misty%20mountain%20background%2C%20ink%20wash%20painting%20style%2C%20ethereal%20atmosphere%2C%20elegant%20composition&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    rating: 9.3,
    views: '2.1亿',
    status: '连载中',
    description: '大千世界，无奇不有。天道崩塌，我陈平安，唯有一剑，可搬山，倒海，降妖，镇魔，敕神，摘星，断江，摧城，开天！',
    updateChapter: '第389话',
    updateDate: '2026-07-01',
    chapters: 389,
    isHot: true,
    isNew: false,
    rank: 3,
    tags: ['修真', '武侠', '仙侠'],
  },
  {
    id: 4,
    slug: 'wu-lian-feng',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '冒险',
    categorySlug: 'maoxian',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%2C%20dark%20haired%20hunter%20with%20glowing%20blue%20eyes%20in%20black%20combat%20suit%2C%20shadow%20army%20behind%20him%2C%20dark%20purple%20and%20black%20atmosphere%2C%20dramatic%20action%20scene%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    rating: 9.6,
    views: '4.5亿',
    status: '连载中',
    description: '十年前，世界与其他次元链接的"门"被打开，被称为"猎人"的觉醒者们拥有了各种超能力。在这个充满危险的世界里，被称为"人类最弱兵器"的E级猎人成振宇，在一次任务中濒临死亡，醒来后发现自己拥有了一个神秘的"系统"。',
    updateChapter: '第179话',
    updateDate: '2026-06-30',
    chapters: 179,
    isHot: true,
    isNew: false,
    rank: 4,
    tags: ['系统', '升级', '战斗'],
  },
  {
    id: 5,
    slug: 'quan-zhi-gao-shou',
    title: '全职高手',
    author: '蝴蝶蓝',
    category: '热血',
    categorySlug: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20style%2C%20esports%20player%20with%20headphones%20at%20keyboard%2C%20glowing%20game%20effects%20surrounding%2C%20cyberpunk%20vibe%2C%20dark%20background%20with%20neon%20accents%2C%20competitive%20gaming%20theme%2C%20dynamic%20composition&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    rating: 9.4,
    views: '3.6亿',
    status: '连载中',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他寄身于一家网吧成了一个小小的网管，但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏。',
    updateChapter: '第312话',
    updateDate: '2026-07-02',
    chapters: 312,
    isHot: false,
    isNew: true,
    rank: 5,
    tags: ['电竞', '游戏', '竞技'],
  },
  {
    id: 6,
    slug: 'shen-yin-shao-nv',
    title: '神印王座',
    author: '唐家三少',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cover%2C%20knight%20in%20golden%20armor%20riding%20white%20horse%2C%20magical%20light%20effects%2C%20grand%20castle%20in%20background%2C%20epic%20fantasy%20atmosphere%2C%20warm%20golden%20lighting%2C%20heroic%20composition&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    rating: 9.1,
    views: '1.8亿',
    status: '连载中',
    description: '少年骑士龙皓晨在圣殿联盟中不断成长，凭借坚定信念与伙伴羁绊，对抗魔族侵袭，守护人类最后的光明与荣耀。',
    updateChapter: '第267话',
    updateDate: '2026-06-28',
    chapters: 267,
    isHot: false,
    isNew: true,
    rank: 6,
    tags: ['骑士', '魔法', '冒险'],
  },
  {
    id: 7,
    slug: 'zhu-xian',
    title: '诛仙',
    author: '萧鼎',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%2C%20young%20cultivator%20in%20cyan%20robe%20standing%20on%20cliff%2C%20ancient%20sword%20in%20hand%2C%20misty%20mountains%20and%20waterfall%2C%20traditional%20ink%20painting%20style%2C%20serene%20yet%20powerful%20atmosphere&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    rating: 9.0,
    views: '2.4亿',
    status: '已完结',
    description: '平凡少年张小凡因命运变故踏入青云门，在正邪纷争与情感纠葛中寻找本心，展开一段波澜壮阔的仙侠旅程。',
    updateChapter: '第198话（完结）',
    updateDate: '2025-08-20',
    chapters: 198,
    isHot: false,
    isNew: false,
    rank: 7,
    tags: ['仙侠', '修真', '古典'],
  },
  {
    id: 8,
    slug: 'yue-lao-de-chong-sheng',
    title: '月老的重生',
    author: '七夜蝴蝶',
    category: '恋爱',
    categorySlug: 'aiqing',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20manhua%20cover%2C%20couple%20under%20cherry%20blossom%20tree%2C%20traditional%20red%20thread%20of%20fate%20connecting%20them%2C%20soft%20pink%20and%20warm%20lighting%2C%20dreamy%20atmosphere%2C%20gentle%20watercolor%20style&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    rating: 8.9,
    views: '1.2亿',
    status: '连载中',
    description: '掌管姻缘的月老意外重生人间，在寻找失落红线的过程中重新理解爱情、命运与守护，开启甜宠又奇幻的新生活。',
    updateChapter: '第156话',
    updateDate: '2026-07-01',
    chapters: 156,
    isHot: false,
    isNew: true,
    rank: 8,
    tags: ['重生', '甜宠', '古风'],
  },
  {
    id: 9,
    slug: 'ling-long',
    title: '玲珑',
    author: '墨香铜臭',
    category: '恐怖',
    categorySlug: 'kongbu',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20manga%20cover%20style%2C%20mysterious%20ancient%20Chinese%20mirror%20with%20ghostly%20reflection%2C%20dark%20room%20with%20candlelight%2C%20eerie%20atmosphere%2C%20traditional%20horror%20elements%2C%20dark%20red%20and%20black%20color%20palette%2C%20suspenseful%20mood&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    rating: 8.7,
    views: '0.9亿',
    status: '连载中',
    description: '一面古老铜镜牵出尘封多年的灵异传说，主角在层层迷雾中追查真相，也逐渐发现自己与玲珑镜之间的隐秘联系。',
    updateChapter: '第89话',
    updateDate: '2026-06-25',
    chapters: 89,
    isHot: false,
    isNew: true,
    rank: 9,
    tags: ['悬疑', '灵异', '惊悚'],
  },
  {
    id: 10,
    slug: 'xing-ji-mi-chong',
    title: '星际迷虫',
    author: '虫族工作室',
    category: '科幻',
    categorySlug: 'kehuan',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20manhua%20cover%2C%20giant%20spaceship%20in%20deep%20space%2C%20alien%20planet%20with%20strange%20vegetation%2C%20astronaut%20in%20futuristic%20suit%2C%20vibrant%20nebula%20colors%2C%20cinematic%20lighting%2C%20epic%20space%20adventure%20vibe&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    rating: 8.5,
    views: '0.7亿',
    status: '连载中',
    description: '深空探索船遭遇未知虫族文明，幸存者必须在陌生星域中求生，并揭开寄生生命与星际战争背后的巨大阴谋。',
    updateChapter: '第67话',
    updateDate: '2026-06-29',
    chapters: 67,
    isHot: false,
    isNew: true,
    rank: 10,
    tags: ['星际', '机甲', '外星'],
  },
  {
    id: 11,
    slug: 'dou-luo-da-lu',
    title: '斗罗大陆',
    author: '唐家三少',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%2C%20boy%20with%20blue%20silver%20grass%20spirit%2C%20martial%20arts%20pose%2C%20glowing%20soul%20rings%2C%20ancient%20Chinese%20palace%20background%2C%20epic%20atmosphere%2C%20dynamic%20action%20scene&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    rating: 9.2,
    views: '6.1亿',
    status: '连载中',
    description: '唐三带着前世记忆来到斗罗大陆，在武魂觉醒、伙伴同行与学院修炼中不断突破，向魂师巅峰发起挑战。',
    updateChapter: '第456话',
    updateDate: '2026-07-03',
    chapters: 456,
    isHot: true,
    isNew: false,
    rank: 11,
    tags: ['魂师', '学院', '热血'],
  },
  {
    id: 12,
    slug: 'wan-sheng-jie',
    title: '万圣街',
    author: '零子还有钞',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20slice%20of%20life%20manhua%20cover%2C%20cute%20monsters%20living%20in%20modern%20apartment%2C%20vampire%20werewolf%20and%20mummy%20roommates%2C%20bright%20colorful%20illustration%2C%20comedy%20vibe%2C%20casual%20daily%20life%20scene&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    rating: 8.8,
    views: '1.5亿',
    status: '连载中',
    description: '来自不同种族的奇妙室友聚在万圣街，吸血鬼、狼人、木乃伊和天使共同生活，演绎轻松搞笑的日常故事。',
    updateChapter: '第423话',
    updateDate: '2026-07-02',
    chapters: 423,
    isHot: false,
    isNew: false,
    rank: 12,
    tags: ['日常', '妖怪', '轻松'],
  },
];

export const hotComics = comics.filter(c => c.isHot);
export const newComics = comics.filter(c => c.isNew);
export const rankingComics = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);
